import { render, staticRenderFns } from "./TenantHome.vue?vue&type=template&id=3aa668a6"
import script from "./TenantHome.vue?vue&type=script&lang=js"
export * from "./TenantHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports